import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ToastService } from '../../services/toast/toast.service';
@Component({
  selector: 'app-confirm',
  templateUrl: 'confirm.component.html',
  styleUrls: ['confirm.component.scss'],
})
export class ConfirmComponent implements OnDestroy {
  routeParamSubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toastService: ToastService,
  ) {
    this.routeParamSubscription = this.route.params.subscribe((params) => {
      let token = params['token'];
      this._confirmToken(token);
    });
  }

  _confirmToken(token: any) {
    Meteor.apply('confirmToken', [token], {
      wait: false,
      onResultReceived: (error, result: any) => {
        if (error) {
          this.toastService.add({ type: 'ERROR', message: 'serverError' });
          return;
        }
        if (result && result.confirmed) {
          this.toastService.add({
            type: 'SUCCESS',
            message: 'optInSuccessMessage',
            timeout: 10000,
          });
        } else {
          this.toastService.add({
            type: 'ERROR',
            message: 'optInErrorMessage',
            timeout: 10000,
          });
        }
      },
    });
    this.router.navigate(['dashboard']).then();
  }

  ngOnDestroy() {
    if (this.routeParamSubscription) {
      this.routeParamSubscription.unsubscribe();
    }
  }
}
